export * from './slide.directive';
export * from './carousel.component';
export * from './carousel.module';
